import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndpointService } from './endpoint.service';
import { CategoriesRequest } from '../requests/CategoriesRequest';
import { GetAllFilteredCategoriesResponse } from '../responses/GetAllFilteredCategoriesResponse';
import {of, tap} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CategoriesService {
  constructor(private http: HttpClient) {}

  private categoryCache: GetAllFilteredCategoriesResponse;
  private providerIdCache: number | undefined;

  getFilteredCategories(data: CategoriesRequest) {
    if (this.categoryCache && this.isDefaultRequest(data) && this.providerIdCache === data.providerId ) {
      return of(this.categoryCache);
    }
    return this.http.post<GetAllFilteredCategoriesResponse>( EndpointService.getFilteredCategories, data ).pipe(tap({
      next: value => {
        this.categoryCache = value;
        this.providerIdCache = data.providerId;
      },
      error: () => this.clearCache()
    }));
  }


  private isDefaultRequest(request: CategoriesRequest) {
    return !request.benefitType && !request.level && !request.name && request.paginationCriteria.start === 0 && request.paginationCriteria.limit === 1000 && request.bringAll
      && request.isAscending === true && request.orderProperty === 'Name';
  }

  clearCache() {
    this.categoryCache = null;
  }
}
